import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Method from "@/pages/Method";
import Experiences from "@/pages/Experiences";
import BalancedLeader from "@/pages/BalancedLeader";
import Events from "@/pages/Events";
import Journal from "@/pages/Journal";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
      <div className="App bg-ink text-bone min-h-screen">
        <div className="noise-overlay" aria-hidden="true" />
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/method" element={<Method />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/balanced-leader" element={<BalancedLeader />} />
            <Route path="/events" element={<Events />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/dave" element={<Navigate to="/" replace />} />
            <Route path="/programmes" element={<Navigate to="/experiences" replace />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster position="bottom-center" toastOptions={{ style: { background: "#0A131A", border: "1px solid rgba(255,255,255,0.1)", color: "#F8FAFC" } }} />
      </div>
    </ReactLenis>
  );
}

export default App;
